import React from 'react';
import MediumSophisticatedTooltipHeading from '../MediumSophisticatedTooltipHeading';
import SophisticatedTooltipText from '../SophisticatedTooltipText';
import s from './MediumSophisticatedTooltipContent.scss';
var MediumSophisticatedTooltipContent = function (_a) {
    var heading = _a.heading, description = _a.description, prefix = _a.prefix, postfix = _a.postfix;
    return (React.createElement("div", { className: s['root'] },
        prefix && React.createElement("div", { className: s['prefix'] }, prefix),
        React.createElement("div", { className: s['text-block'] },
            React.createElement(MediumSophisticatedTooltipHeading, null, heading),
            description && (React.createElement(SophisticatedTooltipText, null, description)),
            postfix)));
};
MediumSophisticatedTooltipContent.displayName =
    'MediumSophisticatedTooltipContent';
export default MediumSophisticatedTooltipContent;
//# sourceMappingURL=MediumSophisticatedTooltipContent.js.map